import { useState } from 'react'
import AdminFormsNav from './AminFormsNav'
import AdminDDJJ from './AdminDDJJ'
import AdminANEXO from './AdminANEXO'
import AdminAnexoRenovado from './AdminAnexoRenovado'
import AdminDDJJRenovado from './AdminDDJJRenovado'
import { useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAnexoDocRenovado, getConsentimientoUsuarioNuevo, getDDJJNuevo } from '../../actions/index'
import 'reactjs-popup/dist/index.css';
import { useParams } from "react-router"

const FormulariosAdmin = () => {

  const token = localStorage.getItem('token')
  const {userId} = useParams()
  const dispatch = useDispatch() 

  useEffect(()=>{ 
    dispatch(getAnexoDocRenovado(userId, token))
    dispatch(getDDJJNuevo(userId, token))
    dispatch(getConsentimientoUsuarioNuevo(userId, token))
  }, [dispatch, token, userId])
  
  const ddjj = useSelector(state => state.ddjjNuevo)
  const anexoDoc = useSelector(state => state.anexoNuevo)
  const consentimiento = useSelector(state => state.consentimientoNuevo)


  const [screen, setScreen] = useState("")

  const renderTabContent = () => {
    switch (screen) {
      case 'AdminDDJJ':
        return <AdminDDJJ />;
      case 'AdminANEXO':
        return <AdminANEXO />;
     
      case 'ANEXORENOVADO' :
       return <AdminAnexoRenovado ddjj={ddjj} consentimiento={consentimiento} anexoDoc={anexoDoc}/>
       
      case 'DDJJRENOVADO' : 
      return <AdminDDJJRenovado />  

      default:
        return null;
    }
  };

  return (
    <div className='w-full'>
       <AdminFormsNav setScreen={setScreen} />
       {renderTabContent()}
    </div>
  )
}

export default FormulariosAdmin